export default {
    init() {

    },
    finalize() {

      //BIZ-1210:  Open Loader popup, and disable outer key.
      $('#loader_popup').modal({
        backdrop: 'static',
        keyboard: false
      }); //open popup

      $(".remove-enrolment-cross").on("click", function () {
        var enrolment_id = $(this).data("enrolment-id");
        var course_name = $(this).data("course-name");
        $('#enrolmentcoursename').html('" ' + course_name + ' "');
        $('#removeenrolment').data('enrolment-id',enrolment_id);
        $('#remove_enrolment_popup').modal('show'); 
      });

      $("#cancelenrolment").on("click",  function() {
        $('#remove_enrolment_popup').modal('hide');
      })

        $(".remove-enrolment").on("click", function () {
            var enrolment_id = $(this).data("enrolment-id");
            var action="removeenrolment";
            var url = ajaxdta.ajaxurl + "?action=remove_enrolment";
            $(".modal-closebutton").hide();
            $("#fullenrolment").addClass('d-none');
            $("#fullenrolment").hide();
            $("#loading_button_remove").removeClass('d-none');
            $("#loading_button_remove").show();

            $.ajax({
              type: "POST",
              url: url,
              data: {
                enrolment_id: enrolment_id, action:action
              },
              dataType:"JSON",
                success: function (data) {
                   $('#remove_enrolment_popup').modal('hide');  
                    var mString = data.success;
                    if(mString){
                      $("#enrolmentdiv"+ enrolment_id).hide(); 
                      $("#loading_button_remove").addClass('d-none');
                      $("#loading_button_remove").hide();
                      $("#fullenrolment").removeClass('d-none');
                      $("#fullenrolment").show();
                      /* BIZ-741 START After deleting enrolment, enrolment count should be updated */
                      if(data.enrolmentcount == 0){
                        $(".enrolmentcount").hide();
                        $(".enrolmentspan").hide();
                      }else{
                        $(".enrolmentcount").html(data.enrolmentcount);
                      }
                      /* BIZ-741 END After deleting enrolment, enrolment count should be updated */
                    }          
                  },
              });
          });
    }
}


// WEBPACK FOOTER //
// ./scripts/routes/my-enrolments.js